import gql from 'graphql-tag';

export default gql`
  mutation adminCreateFoodSafetyEntry($input: AdminFoodSafetyEntryInput!) {
    adminCreateFoodSafetyEntry(input: $input) {
      id
    }
  }
`;
